import { Overlay } from '@mantine/core';
import { useGoogleLogin } from '@react-oauth/google';
import { useRouter } from 'next/router';
import GoogleButton from 'react-google-button';

import { AuthenticationModuleClientType } from '../../../../types';
import { GOOGLE_AUTH_REDIRECT_URI, GOOGLE_SCOPE } from '../../consts';
import { onShowErrorNotification } from '../notifications';

export const LoginPage: AuthenticationModuleClientType['LoginPage'] = () => {
  const {
    query: { redirectTo }
  } = useRouter();

  const onLogin = useGoogleLogin({
    flow: 'auth-code',
    // TODO doesn't work. See more: https://github.com/MomenSherif/react-oauth/issues/226
    include_granted_scopes: false,
    onError: onShowErrorNotification,
    onNonOAuthError: onShowErrorNotification,
    redirect_uri: GOOGLE_AUTH_REDIRECT_URI,
    scope: GOOGLE_SCOPE,
    state: JSON.stringify({ redirectTo }),
    ux_mode: 'redirect'
  });

  return (
    <Overlay center backgroundOpacity={0}>
      <GoogleButton onClick={onLogin} />
    </Overlay>
  );
};
